import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "checkbox"]

  static values = {
    deleted: { type: Boolean, default: false }
  }

  static classes = ["deleted"]

  deletedValueChanged() {
    this.inputTarget.disabled = this.deletedValue
    this.checkboxTarget.checked = this.deletedValue

    const styles = this.element.classList
    if (this.deletedValue)
      styles.add(...this.deletedClasses)
    else
      styles.remove(...this.deletedClasses)
  }

  markForDeletion(event) {
    this.deletedValue = !this.deletedValue
  }
}
